import { styled } from '@mui/material'
import { Box, Card, Stack, Accordion, AccordionSummary, Typography } from '@mui/material'

export const AccountCard = styled(Card)({
  border: '1px solid #E5E7EB',
  borderRadius: '24px',
  padding: '24px',
  height: '100%',
  boxShadow: 'none',
  '& .MuiPaper-root': {
    boxShadow: 'none',
    padding: 0
  }
})

export const CountBadge = styled(Box)({
  border: '1px solid #E5E7EB',
  borderRadius: '6px',
  padding: '2px 8px',
  color: '#A2AAB8',
  whiteSpace: 'nowrap',
  fontSize: '10px'
})

export const NestedAccordion = styled(Box)({
  position: 'relative'
})

export const LineContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isOnlyChild' && prop !== 'level'
})<{ isOnlyChild?: boolean; level: number }>(({ isOnlyChild, level }) => ({
  position: 'absolute',
  left: '-25px',
  height: isOnlyChild && level === 1 ? '35px' : '100%',
  width: '30px',
  zIndex: 1
}))

export const Line = styled(Box)({
  flex: 1,
  borderLeft: 'solid 1px #E5E7EB'
})

export const CustomAccordion = styled(Accordion)({
  '&.Mui-expanded': {
    margin: '0'
  },
  '.MuiAccordionDetails-root &': {
    marginLeft: '10px'
  },
  disableGutters: true,
  elevation: 0,
  px: 2,
  '&::before': {
    opacity: 0
  }
})

export const CustomAccordionSummary = styled(AccordionSummary)({
  padding: 0,
  border: 'none',
  minHeight: '35px',
  height: '35px',
  '&.Mui-expanded': {
    minHeight: '35px'
  },
  '& .MuiAccordionSummary-content': {
    margin: '0',
    '&.Mui-expanded': {
      margin: '0'
    }
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    position: 'relative',
    left: 0,
    order: -1,
    transform: 'rotate(90deg)',
    '&.Mui-expanded': {
      transform: 'rotate(180deg)'
    }
  }
})

export const AccountName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'level'
})<{ level: number }>(({ level }) => ({
  fontSize: '14px',
  fontWeight: level === 0 ? 400 : 300,
  paddingLeft: '15px',
  color: 'text.body.primary'
}))

export const LeafNodeCounter = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
  marginLeft: '0.5rem'
})

export const CounterLine = styled(Box)({
  flex: 1,
  borderBottom: '1px solid',
  borderColor: '#F7F7F7'
})

export const NestedLineStack = styled(Stack)({
  height: '100%',
  position: 'absolute',
  left: '-50px',
  width: '30px'
})

export const MainLineStack = styled(Stack)({
  height: '100%'
})

export const LastChildBox = styled(Box)({
  flex: 1,
  borderBottom: 'solid 1px #E5E7EB',
  transform: 'translateY(-15px)',
  borderBottomLeftRadius: '6px'
})

export const FlexBox = styled(Box)({
  flex: 1
})

export const ScrollableAccountsContainer = styled(Box)({
  maxHeight: '60vh',
  overflowY: 'auto',
  paddingRight: '8px',
  marginRight: '-8px',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#E5E7EB',
    borderRadius: '3px',
  }
})

export const ExpandIcon = styled(Box)({
  color: '#A2AAB8',
  marginLeft: '0.5px',
  marginRight: '0.5px',
  '& .Mui-expanded': {
    marginRight: '0.5px'
  }
})

